// global
import React, { Component } from 'react';
import { Popup, Icon } from 'semantic-ui-react';
import { PropTypes } from 'prop-types';

class PasswordLabel extends Component {
  render() {
    const { title } = this.props;
    return (
      <React.Fragment>
        {title}
        <Popup trigger={<Icon fitted name='info circle' color='red' inverted />} />
      </React.Fragment>
    );
  }
}

PasswordLabel.defaultProps = {
  title: 'Senha *'
};

PasswordLabel.propTypes = {
  title: PropTypes.string
};
export default PasswordLabel;
